import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlComponent } from "../../control.component";
import { SelectContactControl } from "../select-contact-control.model";
import { FormInlined } from "../../../business-objects/form/form.model";
import { SelectOption } from "../../../../core/interfaces/select-option";
import { ControlType } from "../../../business-objects/control-type/control-type.model";
import { CONTROL_TYPES } from "../../control-types";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

@Component({
    selector: "select-contact",
    template: `
        <ion-select
            [formControl]="formControl"
        >
            <ion-option *ngFor="let option of getOptions()" [value]="option.value">{{ option.label }}</ion-option>
        </ion-select>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SelectContactControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => SelectContactControlComponent), multi: true}
    ]
})
export class SelectContactControlComponent extends ControlComponent {
    @Input() definition: SelectContactControl;
    @Input() form: FormInlined;
    @Output() changes: EventEmitter<any> = new EventEmitter();

    formControl: FormControl;

    protected contactControlType: ControlType;

    constructor(
        protected elemRef: ElementRef,
        protected appFacade: VasAppFacade
    ) {
        super(elemRef);
        this.formControl = new FormControl();
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.appFacade.objects.controlType.store
            .getAll()
            .take(1)
            .subscribe(controlTypes => this.contactControlType = controlTypes.find(controlType => controlType.name === "contact"));

        this.formControl.valueChanges
            .takeUntil(this.ngUnsubscribe)
            .subscribe(value => this.updateValue(value));
    }

    writeValue(value: any): void {
        this.formControl.setValue(value);
        super.writeValue(value);
    }

    getOptions(): Array<SelectOption> {

        if (!this.contactControlType) {
            console.warn("cannot find control type for 'contact'");
            return [];
        }

        const options = [];

        this.form.groups
            .forEach(group => group.controls
                // #273
                    .filter(control => control.controlType.name === CONTROL_TYPES.CONTACT)
                    .forEach(control => {
                        options.push(new SelectOption(control.id, control.title));
                    })
            );

        return options;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/select-contact/form/select-contact-control.component.ts